import StyledButton from '../styled/StyledButton';
import { useTranslation } from '@/i18n';

interface ReservationRequestAcceptedModalProps {
  closeModal: () => void;
}

const ReservationRequestAcceptedModal = ({
  closeModal,
}: ReservationRequestAcceptedModalProps) => {
  const { t } = useTranslation();
  return (
    <dialog
      open
      className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center overflow-auto bg-black/50"
    >
      <div className="flex flex-col justify-between min-w- max-w-1/4 gap-8 p-6 border rounded-md border-gray-200 bg-white">
        <div className="flex flex-col gap-2">
          <h1 className="text-lg leading-6 font-semibold text-gray-950">
            {t('estimates.modals.reservationRequestAccepted.title')}
          </h1>
          <p className="text-sm leading-6 font-normal text-gray-600">
            {t('estimates.modals.reservationRequestAccepted.message')}
          </p>
        </div>
        <div className="flex flex-row-reverse">
          <div>
            <StyledButton
              variant="link"
              className="px-3 py-2 border border-gray-300 rounded-lg text-gray-800"
              title={t(
                'estimates.modals.reservationRequestAccepted.actionTitle',
              )}
              onClick={closeModal}
            />
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default ReservationRequestAcceptedModal;
